export const daysAgo = (dt) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    const days = Math.round(Math.abs((new Date() - dt) / oneDay));
    return `${days} day${days === 1 ? '' : 's'} ago`;
};
